{
    "warning": "ਚੇਤਾਵਨੀ!",
    "message": "ਉਹ ਕੋਡ ਦਾਖਲ ਜਾਂ ਪੇਸਟ ਨਾ ਕਰੋ ਜਿਸ ਦੀ ਤੁਹਾਨੂੰ ਸਮਝ ਨਹੀਂ ਹੈ।\nਇਸ ਕੰਸੋਲ ਦੀ ਵਰਤੋਂ ਕਰਨ ਨਾਲ ਹਮਲਾਵਰ ਤੁਹਾਡੀ ਪਛਾਣ ਬਣਾ ਸਕਦੇ ਹਨ ਅਤੇ Self-XSS ਨਾਮਕ ਹਮਲੇ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤੁਹਾਡੀ ਜਾਣਕਾਰੀ ਚੋਰੀ ਕਰ ਸਕਦੇ ਹਨ।"
}
